import { OrderQuoteStatus, OrderStatus } from '@codezo/graphql';

/**
 * Shared status labels/tones.
 *
 * The pages here each grew their own inline copy (OrdersPage, QuotesPage,
 * QuoteDetailPage…). New code should use these instead of adding another;
 * the existing pages can migrate onto them when they're next touched. Mirrors
 * the admin app's lib/status-configs.ts.
 */

export type StatusTone = 'success' | 'warn' | 'info' | 'neutral' | 'danger';

export interface StatusConfig {
	label: string;
	tone: StatusTone;
}

export const ORDER_STATUS: Record<string, StatusConfig> = {
	[OrderStatus.Pending]: { label: 'Pending', tone: 'warn' },
	[OrderStatus.InProduction]: { label: 'In Production', tone: 'info' },
	[OrderStatus.Completed]: { label: 'Completed', tone: 'success' },
	[OrderStatus.Cancelled]: { label: 'Cancelled', tone: 'danger' },
};

export const ORDER_QUOTE_STATUS: Record<string, StatusConfig> = {
	[OrderQuoteStatus.Draft]: { label: 'Draft', tone: 'neutral' },
	[OrderQuoteStatus.Requested]: { label: 'Requested', tone: 'info' },
	[OrderQuoteStatus.Pending]: { label: 'Pending', tone: 'warn' },
	[OrderQuoteStatus.PendingReview]: { label: 'Awaiting confirmation', tone: 'info' },
	[OrderQuoteStatus.Submitted]: { label: 'Submitted', tone: 'info' },
	[OrderQuoteStatus.Accepted]: { label: 'Accepted', tone: 'success' },
	[OrderQuoteStatus.Rejected]: { label: 'Rejected', tone: 'danger' },
	[OrderQuoteStatus.Expired]: { label: 'Expired', tone: 'neutral' },
};

export function statusConfig(map: Record<string, StatusConfig>, status: string): StatusConfig {
	return map[status] ?? { label: status, tone: 'neutral' };
}
